import { ref, Ref, watch, nextTick } from "vue";

interface FormTrackingUtils {
  formChanged: Ref<boolean>;
  resetTracking: () => void;
}

/**
 * This hook provides the tools for form tracking.
 *
 * @param {reactive} form: the component form
 * @returns
 *    {bool} formChanged: the state representing wether the form has changed.
 *    {function} resetTracking: a function that will set the new form status base.
 */
export default function useFormTracking(form: Record<string, unknown>): FormTrackingUtils {
  const formChanged = ref<boolean>(false);
  const initialForm = ref<string>(JSON.stringify({ ...form }));

  watch(form, (watchedForm): void => {
    const hasChanged = JSON.stringify(watchedForm) !== initialForm.value;
    if (hasChanged) {
      formChanged.value = true;
    }
  });

  const resetTracking: () => void = async () => {
    await nextTick();
    initialForm.value = JSON.stringify({ ...form });
    formChanged.value = false;
  };

  return { formChanged, resetTracking };
}
